import styled from 'styled-components';

import { appColors } from './config/colors';
import { Block, H2 } from '../../../styles/styledComponents';

export const Wrapper = styled.section`
    margin: 3rem 0 5rem;
`;

export const Indent = styled(Block as any)``;

export const Question = styled(H2 as any)`
    margin-bottom: 1em;
`;

export const Description = styled.p`
    margin-bottom: 2em;
`;

export const Answer = styled.p<{ isVisible: boolean }>`
    display: inline;
    color: ${({ isVisible }) => (isVisible ? 'inherit' : 'transparent')};
    background-color: ${({ isVisible }) => (isVisible ? appColors.backgroundPrimary : appColors.hiddenText)};
    user-select: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
    pointer-events: ${({ isVisible }) => (isVisible ? 'all' : 'none')};
    transition: all 0.25s ease;
`;

export const LegendWrapper = styled.div`
    display: flex;
    align-items: baseline;
    background-color: ${appColors.backgroundSecondary};
    margin-bottom: 1.5rem;
    padding: 0.5rem;
`;

export const StarWrapper = styled.div<{ alignRight?: boolean }>`
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    margin-right: 0.5rem;
    margin-left: ${({ alignRight }) => (alignRight ? 'auto' : '.5rem')};

    > div {
        margin: 0 auto;
    }
`;

export const Button = styled.button`
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${appColors.buttonFont};
    background: ${appColors.buttonBackground};
    font-size: 1rem;
    border: 0;
    line-height: 1.5;
    border-radius: 5px;
    padding: 0.25rem 0.5rem;
    margin: 0 0.25rem;
    cursor: pointer;

    svg {
        vertical-align: middle;
    }
`;
